import { useTheme } from '@mui/material';

interface IProps {
  size?: number | string;
  stroke?: string;
}

export const EyePinIcon = ({ size, stroke }: IProps) => {
  const theme = useTheme();

  return (
    <svg id="eyepinicon__assets-icons-v2__svg__l12"
    xmlns="http://www.w3.org/2000/svg"
    width={size ? size : 24}
    height={size ? size : 24}
    viewBox="0 0 24 24"
    fill="none"
    stroke={stroke ? stroke : theme.palette.primary.main}
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icons-tabler-outline icon-tabler-eye-pin">
      
      <path id="eyepinicon__assets-icons-v2__path__l24" stroke="none" d="M0 0h24v24H0z" fill="none" />
      <path id="eyepinicon__assets-icons-v2__path__l25" d="M10 12a2 2 0 1 0 4 0a2 2 0 0 0 -4 0" />
      <path id="eyepinicon__assets-icons-v2__path__l26" d="M12 18c-3.6 0 -6.6 -2 -9 -6c2.4 -4 5.4 -6 9 -6c3.362 0 6.202 1.745 8.517 5.234" />
      <path id="eyepinicon__assets-icons-v2__path__l27" d="M21.121 20.121a3 3 0 1 0 -4.242 0c.418 .419 1.125 1.045 2.121 1.879c1.051 -.89 1.759 -1.516 2.121 -1.879z" />
      <path id="eyepinicon__assets-icons-v2__path__l28" d="M19 18v.01" />
    </svg>);

};